export default "/images/product-1.png?a98b9eafe42f2a3e9fb8967f58299cf0";